export const isAnyActionPending = (...flags) => flags.some(Boolean);

export const guardDialogClose = (isLocked, onClose) => (event, reason) => {
  if (isLocked) return;
  onClose?.(event, reason);
};
